import {
  useGetCompanyFirstHireByCountryQuery,
  useGetCurrentCompanyBusinessDescriptionQuery,
} from "types/generated/operations";

type Params = {
  workCountry: string;
};

type Result = {
  loading: boolean;
  shouldShow: boolean;
  shouldRequire: boolean;
};

export function useClientBusinessDescriptionRequirement({
  workCountry,
}: Params): Result {
  const { data: firstHireData, loading: firstHireLoading } =
    useGetCompanyFirstHireByCountryQuery({
      variables: { workCountry },
      skip: !workCountry,
    });

  const { data: businessDescriptionData, loading: businessDescriptionLoading } =
    useGetCurrentCompanyBusinessDescriptionQuery();

  const loading = firstHireLoading || businessDescriptionLoading;

  const isFirstHire =
    firstHireData?.companyFirstHireByCountry?.isFirstHire ?? false;
  const businessDescription =
    businessDescriptionData?.currentMember?.company?.businessDescription;

  const shouldShow =
    !loading && (Boolean(isFirstHire) || !Boolean(businessDescription));
  const shouldRequire = shouldShow;

  return { loading, shouldShow, shouldRequire };
}

export default useClientBusinessDescriptionRequirement;
